import { useContext, useEffect, useState } from "react";
import i18n from "../../../i18n";
import { RootContext } from "../../../providers/RootProvider";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import PoolGameList from "../components/PoolGamesList/PoolGamesList";
import { useAptabase } from "@aptabase/react";
import GameDetails from "../components/GameDetails/GameDetails";
import { useFetchGames } from "../../../api/hooks";

const GamesPage = () => {
  const { selectedPhaseId } = useContext(RootContext);
  const { trackEvent } = useAptabase();
  const [selectedGameId, setSelectedGameId] = useState<string | null>(null);

  const { data: games } = useFetchGames(selectedPhaseId);

  const selectedGame = games?.find((game) => game._id === selectedGameId);

  useEffect(() => {
    trackEvent("page_view", { screenName: "games_page" });
  }, [trackEvent]);

  return (
    <PageContainer title={i18n.t("navigation:games:title")}>
      {games ? (
        <PoolGameList
          games={games}
          onGameClick={(game) => setSelectedGameId(game._id)}
        />
      ) : null}
      <GameDetails
        game={selectedGame}
        open={Boolean(selectedGame)}
        onClose={() => setSelectedGameId(null)}
      />
    </PageContainer>
  );
};

export default GamesPage;
